import situation from '@/locales/pt/tests/situation';
import problems from '@/locales/pt/tests/problems';
import resources from '@/locales/pt/tests/resources';

export default {
  home: {
    title: 'Teste-se a si mesma',
  },
  result: {
    title: 'Os seus resultados',
    nextTests: 'Faça o próximo teste:',
  },
  situation: {
    title: 'Teste de Primeiros Socorros',
    ...situation,
  },
  problems: {
    title: 'Teste de Resolução de Problemas',
    ...problems,
  },
  resources: {
    title: 'Teste das Forças',
    ...resources,
  },
  ressources: {
    title: 'Teste das Forças',
    ...resources,
  },
  email: {
    title: 'Receba os seus resultados por e-mail',
    label: 'O seu endereço de e-mail',
    validators: {
      required: 'É necessário um endereço de e-mail',
      valid: 'O endereço de e-mail não é válido',
    },
    notification: {
      sending: 'A enviar o e-mail...',
      sent: 'O e-mail foi enviado com sucesso 🎉',
    },
    template: {
      subject: {
        situation: 'Primeiros socorros | profemina',
        problems: 'A sua decisão | profemina',
        resources: 'As suas forças | profemina',
        ressources: 'As suas forças | profemina',
      },
      cta: '<a href="mailto:acompanhamento@profemina.org?subject=Eu gostava de contactar uma counsellor&body=Cara equipa profemina,%0D%0A%0D%0AEu gostava de ser acompanhada gratuitamente por uma counsellor.">Para ser acompanhada individualmente, clique aqui</a>',
      greeting: 'Olá,',
      message: 'Estamos satisfeitos por nos ter contactado e esperamos que esta avaliação lhe tenha sido útil. Pode consultar aqui, novamente, o seu resultado individual.',
      signatureGreeting: 'Esperamos que tudo lhe corra o melhor possível no caminho que tem diante de si!<br>Atentamente,',
      signature: 'A equipa de acompanhamento da <i>profemina</i>',
      ps: 'PS: Temos todo o prazer em continuar a apoiá-la! Sinta-se à vontade para utilizar os outros testes que colocámos ao seu dispor: Teste de Primeiros Socorrors, Teste das Forças, Teste de Personalidade, Teste de Resolução de Problemas, Teste do Aborto',
      contact: 'ACOMPANHAMENTO PROFEMINA<br><br>Informação, acompanhamento e ajuda para mulheres grávidas: <a href="https://www.profemina.org/pt-pt/">www.profemina.org</a><br><br>Acompanhamento direto, individual e personalizado em português (por Ponto de Apoio à Vida, Portugal):<br>Acompanhamento telefónico Rede Fixa: (+351) 211 337 061<br>Acompanhamento por Telemóvel: (+351) 913 590 220 (também possível via WhatsApp)<br>Acompanhamento por E-mail: <a href="mailto:acompanhamento@profemina.org">acompanhamento@profemina.org</a><br><br>O acompanhamento é gratuito.',
      footer: 'Este serviço de acompanhamento digital é disponibilizado por:<br>Profemina International Impresa Sociale S.r.l. • Via dei Portici 76 • 39100 Bolzano • Italia<br>Inscrição no Registo Comercial Bolzano • Número de registo, identificação fiscal e IVA: 03117840219<br>Representante autorizado: Kristijan Aufiero, Diretor Executivo • <a href="https://www.profemina.org/pt-pt/aviso-legal">Aviso Legal</a><br><br>OS NOSSOS SERVIÇOS DE ACOMPANHAMENTO:<br>A <i>profemina</i> é um serviço internacional de acompanhamento independente, especializado e sem fins lucrativos para mulheres em crise diante de uma gravidez. Através de informação objetiva, acompanhamento de excelência e cada vez mais diversificado, bem como de apoios concretos, queremos dar a cada mulher em crise diante de uma gravidez a possibilidade de tomar uma decisão autodeterminada e independente.<br>Aprendemos com mais de 100.000 mulheres que acompanhámos que a pressão exterior das circunstâncias e das pessoas é a causa mais frequente para uma crise na gravidez e a decisão de fazer um aborto.<br>É preocupação da <i>profemina</i> estar ao lado das mulheres grávidas em dificuldade e elaborar uma alternativa resiliente ao aborto com e para todas as MULHERES QUE O QUEIRAM, permitindo-lhes assim tomar uma decisão LIVRE.<br><br>O nosso trabalho é financiado exclusivamente por donativos particulares das pessoas que nos apoiam e que se preocupam com as mulheres grávidas em dificuldade. Por isso, o nosso acompanhamento é 100% gratuito para cada mulher que procura acompanhamento e ajuda.<br><br>Pode saber mais sobre os princípios do nosso trabalho <a href="https://www.profemina.org/pt-pt/sobre-nos/nosso-trabalho">aqui</a>.<br><br>INFORMAÇÃO SOBRE PRIVACIDADE:<br>Todos os seus dados e informações serão considerados estritamente confidenciais e não serão transmitidos a pessoas não autorizadas, estando sujeitos à proteção total do decreto RGPD (Regulamento Geral de Proteção de Dados). Todas as informações importantes sobre o processamento de dados, especialmente as relativas ao decreto RGPD (Regulamento Geral de Proteção de dados) podem ser encontradas <a href="https://www.profemina.org/pt-pt/politica-de-privacidade">aqui</a>.<br><br>NOTA SOBRE CONFIDENCIALIDADE:<br>Este e-mail e caso existam, seus respetivos anexos, destinam-se exclusivamente à utilização pelo(s) destinatário(s). Este e-mail e, caso existam, seus respetivos anexos, podem, nos termos da lei aplicável, conter informações consideradas confidenciais, cuja divulgação ou reencaminhamento não estão autorizados.<br>Caso não seja o destinatário previsto deste e-mail, está proibido de divulgar, reproduzir, distribuir, difundir ou fazer uso deste conteúdo de qualquer outra forma. O envio deste e-mail a qualquer pessoa que não seja o destinatário previsto não constitui uma renúncia da nossa parte, a quaisquer direitos ou privilégios. Se tiver recebido este e-mail por engano, informe imediatamente o remetente enviando um e-mail de resposta e elimine prontamente este e-mail do seu sistema.',
    },
  },
  rating: {
    title: 'Temos todo o gosto em receber os seus comentários 🤗',
    question1: '<strong>Até que ponto se sentiu ajudada por este teste no seu processo de tomada de decisão?</strong>',
    question2: '<strong>Sentiu-se confortável e à vontade durante o teste?</strong>',
    question3: '<strong>Voltaria a utilizar esta aplicação?</strong>',
    textarea: {
      question: '<strong>Há alguma coisa que gostasse de partilhar connosco?</strong>',
      label: 'Os seus comentários (opcional)',
    },
    processing: 'A processar os seus comentários...',
    thanks: 'Muito obrigado pelos seus comentários 🤗',
  },
  welcome: 'Bem-vinda à aplicação de testes da <i>profemina</i>',
  language_switcher: {
    de: 'Alemão',
    en: 'Inglês',
    pt: 'Português',
    it: 'Italiano',
  },
  bottom_bar: {
    next: 'Continuar',
    advice: 'Mostrar resultados',
  },
refreshApp: {
    title: 'A <i>profemina</i> está a melhorar 🎉',
    description: 'Está disponível uma nova versão. Por favor carregue em "ATUALIZAR" para obter a versão mais recente.',
    button: 'Atualizar',
  },
  loading: 'Estamos a preparar os resultados do seu acompanhamento online',
  notFound: {
    title: '404 - Página não encontrada',
    subtitle: 'Ops! Pedimos desculpa...',
    text: 'Parece que há um problema com esta página.',
  },
  connectivity: {
    offline: 'Você acabou de ficar offline...',
    online: 'Que bom, você está online outra vez 🤗',
  },
};
